import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { GetWalletTypesResponse } from "../../models/wallet.model";
import { Box } from "@mui/material";
// import "./checkboxImage.css";
interface CheckboxImageProps {
  walletType: GetWalletTypesResponse[];
  setArrayCard: React.Dispatch<React.SetStateAction<any>>;
  arrayCardList: any[];
  setIsCheckedWallet: Function;
}

export default function CheckboxImage(walletType: CheckboxImageProps) {
  const changeCheckbox = (e: any, value: any) => {
    walletType.setArrayCard(value.id);
    walletType.setIsCheckedWallet(e.target.checked);
  };

  return (
    <>
      {walletType.walletType.map((item) => (
        <FormGroup style={{ marginTop: "30px" }}>
          <FormControlLabel
            control={
              <Checkbox
                onClick={(e) => changeCheckbox(e, item)}
                checked={
                  walletType.arrayCardList.includes(item.id) ? true : false
                }
              />
            }
            label={
              <div style={{ alignItems: "center", display: "flex" }}>
                {/* <div
                  style={{
                    width: "15vh",
                    height: "8vh",
                    backgroundColor: item.color || "gray",
                    display: "inline-block",
                  }}
                ></div> */}
                <Box
                  className="carousel-cards"
                  sx={{
                    paddingInline: "10px",
                    position: "relative",
                    width: "100px",
                    height: "55px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                  style={{
                    borderRadius: "5px",
                    background: `linear-gradient(160deg,rgba(255,255,255,.85), ${item?.color})`,
                  }}
                ></Box>{" "}
                <span
                  className="defualtColor"
                  style={{
                    fontSize: "1.125rem",
                    fontWeight: "bold",
                    paddingRight: "2vh",
                  }}
                >
                  {item.title}
                </span>
              </div>
            }
          />
        </FormGroup>
      ))}
    </>
  );
}
